@if (isDamageCodesList) {
  <div class="pure-g m-t-16" style="align-items: center; display: flex; justify-content: flex-end">
    <div class="pure-u-md-6-24 pure-u-lg-5-24 pure-u-xl-4-24 right">
      @if (isDamageCodeAddEnabled()) {
        <mc-button
          label="Add new"
          routerLink="/master-data/damage-code/add-new"
          variant="filled"
          appearance="primary"
          fit="small"></mc-button>
      }
    </div>
  </div>
}

<div class="filter-utility-row m-t-8">
  <div class="quick-filter-box">
    <div class="p-l-4 applied-filter-holder">
      @for (taggedFilter of taggedFilters; track taggedFilter.key) {
        <div class="m-r-4" style="white-space: nowrap">
          {{ taggedFilter.key }}
        </div>

        @if (taggedFilter.key == 'Damage Code - Description' && getTaggedDamageCode().length > 0) {
          <app-tag-with-overflow
            [data]="getTaggedDamageCode()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectDamageCodeByValue()">
          </app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Damage Type' && getTaggedDamageType()) {
          @for (taggedDamageType of getTaggedDamageType(); track taggedDamageType) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              padding="compact"
              withaction
              (dismiss)="unselectSpecificFilter(taggedFilter, $index)"
              [attr.aria-label]="'Remove filter ' + getTaggedFilterValue(taggedFilter, $index)">
              {{ getTaggedFilterValue(taggedFilter, $index) }}
            </mc-tag>
          }
        }
      }
      @if (taggedFilters.length > 0) {
        <a>
          <mc-button
            class="clear-btn"
            variant="plain"
            appearance="primary"
            fit="small"
            padding="default"
            (click)="clearAllSelectedFilters()"
            (keydown.enter)="clearAllSelectedFilters()"
            (keydown.space)="$event.preventDefault(); clearAllSelectedFilters()">
            Clear All
          </mc-button>
        </a>
      }
    </div>
    <div class="utility-buttons">
      @if (authPolicies.canViewDamageCode) {
        <mc-button
          class="utility-button"
          label="Button"
          variant="filled"
          appearance="neutral"
          fit="medium"
          [loading]="isDownload"
          icon="tray-arrow-down"
          hiddenlabel
          padding="default"
          (click)="onDownload()"
          (keydown.enter)="onDownload()"
          (keydown.space)="$event.preventDefault(); onDownload()">
        </mc-button>
      }

      <mc-button
        class="utility-button-inner"
        slot="trigger"
        label="Button"
        icon="sliders-horizontal"
        variant="filled"
        appearance="neutral"
        hiddenlabel
        padding="default"
        fit="medium"
        (click)="showAdvanceFiltersModal()"
        (keydown.enter)="showAdvanceFiltersModal()"
        (keydown.space)="$event.preventDefault(); showAdvanceFiltersModal()">
      </mc-button>
    </div>
  </div>

  <mc-modal
    backdropcloseactiondisabled
    [open]="showAdvanceFilters"
    (closed)="closeAdvanceFiltersModal()"
    heading="Filters"
    fit="small"
    dimension="large">
    <app-damage-code-advance-filter
      [isDamageCodesList]="isDamageCodesList"
      [bindMultiSelects]="showAdvanceFilters"
      [damageCodeFilterForm]="filterFormGroup.controls.damageCodeFilterForm"></app-damage-code-advance-filter>
  </mc-modal>
</div>
